import React from "react";
import axios from "axios";
import setUpAxios from "../helperFunctions/helperFunctions";

export default class ChargebeePortalLink extends React.Component<
  { site: string; text: string; id?: string },
  { portal: any }
> {
  state = {
    portal: null,
  };

  componentDidMount(): void {
    setUpAxios();
    const instance = (window as any).Chargebee.init({ site: this.props.site });
    instance.setPortalSession(function returnPortal() {
      return axios
        .get("/api/frontend/chargebee_portal_sessions")
        .then((response) => {
          return response.data.portalSession;
        });
    });
    this.setState({ portal: instance.createChargebeePortal() });
  }

  openPortal = (): void => {
    const options = {
      close: (): void => {
        window.location.reload();
      },
    };

    this.state.portal.open(options);
  };

  render(): JSX.Element {
    return (
      <a
        className="subscription btn btn-primary"
        id={this.props.id}
        onClick={this.openPortal}
      >
        {this.props.text}
      </a>
    );
  }
}
